import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RedefinirSenha } from '@/features/auth/componentes/RecuperarSenha';

/** Link do email de convite e de redefinição, para equipe e alunos (spec 002). */
const busca = z.object({
  token: z.string().optional(),
  tipo: z.literal('convite').optional().catch(undefined),
});

export const Route = createFileRoute('/redefinir-senha')({
  validateSearch: busca,
  component: PaginaRedefinirSenha,
});

function PaginaRedefinirSenha() {
  const { token, tipo } = Route.useSearch();
  return <RedefinirSenha token={token} convite={tipo === 'convite'} />;
}
